import {
  CreditCardFormNotValidError,
  PaymentActionRequiredError,
  PaymentCardUnsupportedError,
  PaymentConfirmationError,
  PaymentGeneralError,
  PaymentSavedCreditCardPayError,
} from '@seek/payments-widget';

export const isIgnoredError = (error: Error) => {
  const expectedError = [
    PaymentCardUnsupportedError,
    PaymentConfirmationError,
    PaymentGeneralError,
    PaymentSavedCreditCardPayError,
    PaymentActionRequiredError,
    CreditCardFormNotValidError,
  ].find((err) => error instanceof err);

  return Boolean(expectedError);
};
